import { validate } from "rut.js";

export const isRutRequired = ({
	hasRut,
	isLoggedIn,
	isLoggedInTemporary,
	modeRut,
	modeDni,
}) => {
	if (modeDni) {
		return false;
	}

	return (
		(!isLoggedIn && modeRut) ||
		(isLoggedIn && !hasRut && modeRut) ||
		(isLoggedInTemporary && !hasRut && modeRut)
	);
};

export const isDniRequired = ({
	hasDni,
	isLoggedIn,
	isLoggedInTemporary,
	modeDni,
	modeRut,
}) => {
	if (!modeRut && !modeDni) {
		return false;
	}

	return (
		(!isLoggedIn && modeDni) ||
		(isLoggedIn && !hasDni && modeDni) ||
		(isLoggedInTemporary && !hasDni && modeDni)
	);
};

export const validateRut = (rut) => {
	if (!rut && rut.length < 8) {
		return false;
	}
	return validate(rut);
};

export const validateDni = (dni) => {
	if (!dni.match(/^[0-9]+$/) || dni.length < 7) {
		return false;
	}

	return true;
};
